import React from "react";
import { ClickAwayListener, Divider } from "@mui/material";
import { Dropdown } from "react-bootstrap";
import { MoreVert as ThreeDotIcon } from "@mui/icons-material";
import ReactDOM from "react-dom";
import "./styles.css";  // We'll create this file next

const MenuPopup = ({
  setOpen,
  open,
  handleClose,
  menuItems,
  data,
  maxHeight = "270",
  bottom = 3,
  isShowPortal = false,
  direction = undefined,
  hideToggleIcon = true, // New prop to control toggle icon visibility
}) => {
  const renderMenuContent = () => (
    <Dropdown.Menu
      variant=" shadow"
      style={{
        minWidth: 180,
        zIndex: 1000000,
      }}
    >
      {menuItems.map((item, index) => (
        <React.Fragment key={index}>
          <Dropdown.Item
            onClick={(event) => {
              event.stopPropagation();
              !item?.isDisabled && handleClose();
              !item?.isDisabled && item?.action(data);
            }}
            disabled={!!item?.isDisabled}
            style={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            {item.icon}
            <span style={{ marginLeft: 8, marginRight: "5px" }}>
              {item.label}
            </span>
          </Dropdown.Item>
          {index < menuItems.length - 1 && (
            <Divider style={{ backgroundColor: "#e0e0e0" }} />
          )}
        </React.Fragment>
      ))}
    </Dropdown.Menu>
  );
  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Dropdown
        show={open}
        style={{ bottom: bottom, left: 10 }}
        autoClose="outside"
        drop={direction}
      >
        <Dropdown.Toggle
          variant="none"
          className="no-toggle-icon"
          style={{ border: 0, margin: 0, padding: 0 }}
          id="dropdown-autoclose-true"
        >
          <ThreeDotIcon
            style={{ fontSize: 20, cursor: "pointer" }}
            onClick={(event) => {
              event.stopPropagation();
              setOpen(data?.id);
            }}
          />
        </Dropdown.Toggle>
        {isShowPortal
          ? ReactDOM.createPortal(renderMenuContent(), document.body)
          : renderMenuContent()}
      </Dropdown>
    </ClickAwayListener>
  );
};

export default MenuPopup;
